import styled from 'styled-components';

import { ButtonComponent } from '@nw/design-system/omega';

export const VerifyOtpButtonContainer = styled(ButtonComponent)<{
  isDisabled: boolean;
}>`
  opacity: ${({ isDisabled }) => (isDisabled ? '0.5' : '1')};
`;

export const VerifyAndSignUpText = styled.span``;
